import React, {useState} from "react";
import classnames from 'classnames'
import {useDealContext} from "../../contexts/DealContext";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {DealRebateModal} from "./DealRebateModal";
import CurrencyInput from "react-currency-input-field";
import Checkbox from "@mui/material/Checkbox";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useMediaQuery} from "react-responsive";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import useRebateStateHook from "../../hooks/useRebateStateHook";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import Stack from "@mui/material/Stack";

export const FirstPaymentWaiverItem = ({firstPaymentWaiverAmount}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {updateDealResponse} = useDealContext()
    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <TableRow>
            <TableCell
                align="left"
                width={isTabletOrMobile ? '1%' : '20%'}
            >
                <span
                    style={{
                        color: '#666666',
                    }}
                >
                    First Payment Waiver
                </span>
            </TableCell>
            <TableCell
                align="right"
                width={isTabletOrMobile ? '50%' : '20%'}
            >
                <div
                    style={{
                        display: isTabletOrMobile ? 'flex' : '',
                        flexDirection: isTabletOrMobile ? "row" : '',
                        alignItems: isTabletOrMobile ? 'center' : ''
                    }}
                >
                    <CurrencyInput
                        className={'payment-row_value disabled'}
                        prefix="$"
                        value={firstPaymentWaiverAmount}
                        disabled={true}
                        style={{ width: isTabletOrMobile ? '100%' : ''}}
                    />
                    {
                        isTabletOrMobile &&
                        <div

                        >
                            <MoreVertIcon onClick={handleClick}/>
                            <Popover
                                onClick={(e) => e.stopPropagation()}
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top'
                                }}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Applied
                                    </Typography>
                                    <Checkbox
                                        className={classnames('payment-row_value', {
                                            isDisabled: true,
                                        })}
                                        checked={true}
                                        disabled={true}
                                    />
                                </Stack>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Taxed
                                    </Typography>
                                    <Checkbox
                                        className={classnames('payment-row_value', {
                                            isDisabled:true,
                                        })}
                                        checked={true}
                                        disabled={true}
                                    />
                                </Stack>
                            </Popover>
                        </div>
                    }
                </div>
            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        width={isTabletOrMobile ? '5%' : '10%'}
                        align="right"
                    >
                        <Checkbox
                            className={classnames('payment-row_value', {
                                isDisabled: true,
                            })}
                            checked={true}
                            disabled={true}
                        />
                    </TableCell>
                    <TableCell
                        align="right"
                        width={isTabletOrMobile ? '5%' : '10%'}
                    >
                        <Checkbox
                            className={classnames('payment-row_value', {
                                isDisabled: true,
                            })}
                            checked={true}
                            disabled={true}
                        />
                    </TableCell>
                </React.Fragment>
            }
        </TableRow>
    )
}